/**
 * Extracts the resolved data payload from a fetcher object.
 */
export const useResult = ({ response }) => response.data;

/**
 * Extracts metadata (if any) from the fetcher response.
 */
export const useMeta = ({ response }) => response.jsonapi?.meta;

/**
 * Extracts useful UI-ready stats (pending state + update count).
 */
export const useStats = ({ response }) => ({
  pending: response.pending,
  updates: response.updates,
});
